import { render } from "./Header.vue?vue&type=template&id=0c40a142&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=0c40a142&scoped=true&lang=css"

import exportComponent from "C:\\Users\\absan\\Documents\\GitHub\\Starport\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c40a142"]])

export default __exports__